import { render } from "./MaterialCatalog.vue?vue&type=template&id=094f4223&scoped=true"
import script from "./MaterialCatalog.vue?vue&type=script&lang=js"
export * from "./MaterialCatalog.vue?vue&type=script&lang=js"

import "./MaterialCatalog.vue?vue&type=style&index=0&id=094f4223&lang=less&scoped=true"
import "./MaterialCatalog.vue?vue&type=style&index=1&id=094f4223&lang=less"
import "./MaterialCatalog.vue?vue&type=style&index=2&id=094f4223&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-094f4223"]])

export default __exports__